<template>
    <div class="row">
        <div v-if="!isViewOnly" v-show="!addingCard" style="text-align: right; padding-right:15px; padding-bottom: 5px;">  <!--v-if="!viewOnly"-->
            <ac-button class="btn btn-blue btn-sm" :action="addCard">
                <span style="color: white !important;">ADD CARD</span>
            </ac-button>
        </div>   
        <div v-show="!addingCard" class="col-md-12">
            <table ref="grid" class="mdl-data-table table table-responsive dataTable no-footer dtr-inline" width="100%"></table>
        </div>
        <div v-show="addingCard" class="col-md-12">
            <ac-credit-card v-model="updatedCard" :askToDefault="this.currentCards !== null" ref="newCardComponent" :showRequiredLabel="true">
            </ac-credit-card>
            <ac-button class="btn btn-green btn-sm pull-right" :action="saveCCInfo" > 
                <span style="color: white !important;">SAVE CARD</span>
            </ac-button>
            <ac-button class="btn btn-red btn-sm pull-right" style="margin-right:10px;" :action="endAddCard">
                <span style="color: white !important;">CANCEL</span>
            </ac-button>
        </div>
        <ac-confirmation-modal ref="confirmDeleteModal" :size-class="'modal-md'"
                                :title="'Delete Credit Card'"
                                :accept-button="'Delete'"
                                :forceWhiteButtons="true">
            <p>
                Are you sure you want to delete this credit card?
            </p>
        </ac-confirmation-modal>
        <ac-confirmation-modal ref="confirmDefaultModal" :size-class="'modal-md'"
                                :title="'Default Credit Card'"
                                :accept-button="'Default'"
                                :forceWhiteButtons="true">
            <p>
                Are you sure you want to change the default credit card?
            </p>
        </ac-confirmation-modal>
    </div>
    
</template>

<script>
    import AcCreditCard from "./AcCreditCard.vue";
    import { notifications } from "../../global/notifications";
    import { common } from "../../global/common";
    import AcButton from '../../global/customHtmlElements/AcButton.vue';
    import { api } from "../../global/framework/api";

    export default {
        name: "AcCurrentCreditCards",
        components: {AcCreditCard, AcButton},
        props: {
            value: {type: [Object], required: true},
            needsSelect: {type: Boolean, default: false},
            isViewOnly: {type: Boolean, default: false}
        },
        data() {
            return {
                currentCards: this.value.currentCards,
                updatedCard: {...this.value.updatedCard, billingAddress: this.value.updatedCard.billingAddress || {}},
                grid: null,
                addingCard: false
            };
        }, 
        async mounted() {
            this.initOrReloadGrid();
        },
        methods: {
            async initOrReloadGrid() {
                let defaultBtn = '<button class="btn btn-xs btn-blue default-card" style="margin-right:5px;" title="Set Default Credit Card"><i class="fa fa-credit-card" style="color:white !important;"></i></button>';
                let defaultCheckmark = `<i class="fa fa-check" title="Default Credit Card" style="color:#475e72 !important; font-size: x-large; padding: .375rem .75rem;"></i>`;
                let deleteBtn = `<button class="btn btn-xs btn-red delete-card" style="color:white !important; margin-right:5px;" title="Delete Credit Card"><i class="fa fa-trash" style="color:white !important;"></i></button>`;
                let selectBtn = '<ac-button class="btn-sm btn-success wl-btn-success select-card" style="cursor:pointer;">SELECT</ac-button>';

                if (this.isViewOnly) {defaultBtn = '';}

                let columns = [
                    { title: "Brand", data: "brand", render(data, type, row){
                        return data;
                    } },
                    { title: "Card Number", data: "maskedCardNumber" },
                    { title: "Expiration Month", data: "expirationMonth"},
                    { title: "Expiration Year", data: "expirationYear"},
                    { title: "Default", name: 'defaultColumn', data: null, sortable: false, render(data, type, row) {
                        return row.isDefault? defaultCheckmark : defaultBtn;
                    }},
                    { title: "Delete", name: 'deleteColumn', data: null, sortable: false, render(data, type, row) {
                        return deleteBtn;
                    }}
                ];

                if(this.needsSelect){
                    columns.unshift(
                    {
                        title: "Select", data: null, render(data, type, row) {
                            return selectBtn;
                        }
                    })
                }

                if (this.grid !== null) {
                    common.reloadGrid(this.grid, this.currentCards);
                    return;
                }

                this.grid = $(this.$refs.grid).DataTable({
                    columns: columns,
                    scrollX: true,
                    data: this.currentCards,
                    displayLength: 10,
                    responsive: true,
                });

                if(this.isViewOnly){
                    this.hideDelete();
                }

                this.addClickEvents();
            },
            async addClickEvents() {
                let self = this;
                $(this.$refs.grid).off("click", ".default-card").on("click", ".default-card", function () {
                    let row = common.getRowData(this, self.grid);

                    self.defaultCard(row);
                });
                $(this.$refs.grid).off("click", ".delete-card").on("click", ".delete-card", function () {
                    let row = common.getRowData(this, self.grid);
                    self.deleteCard(row);
                });
                $(this.$refs.grid).off("click", ".select-card").on("click", ".select-card", function () {
                    let row = common.getRowData(this, self.grid);
                    self.$emit('select', row.paymentMethodId);
                });
            },
            addCard(){
                this.$emit('toggleButtons', false);
                this.addingCard = true;
            },
            endAddCard(){
                this.addingCard = false;
                this.$emit('toggleButtons', true);
            },
            async getPaymentMethodId() {
                return this.$refs.newCardComponent.getPaymentMethodId();
            },
            async getNewDefaultBool() {
                return this.$refs.newCardComponent.getNewDefaultBool();
            },
            async saveCCInfo(){
                this.endAddCard();
                this.$emit('save');
            },
            async deleteCard(rowData) {
                if(rowData.isDefault){
                    notifications.showError({ title: "Error", message: "Must assign a new default credit card before deleting the default credit card." });
                    return null;
                }

                let agree = await this.$refs.confirmDeleteModal.showModal();
                if (agree) {
                    this.$emit('delete', {paymentMethodId: rowData.paymentMethodId});
                }
            },
            async defaultCard(rowData){
                let agree = await this.$refs.confirmDefaultModal.showModal();                
                if(agree){
                    this.$emit('default', {paymentMethodId: rowData.paymentMethodId});
                }
            },
            hideDelete(){
                var deleteColumn = this.grid.column('deleteColumn:name');
                deleteColumn.visible(false);
            }
        }
    }
</script>

<style scoped>

</style>